import React from 'react'
import { array } from 'prop-types'
import cx from 'classnames'

import { useNavigate } from 'react-router-dom'
import useGetCategoryName from '../../../../hooks/useGetCategoryName'

import CreateGuideDialog from '../create-guide-dialog'
import Flag from '../../../shared/flag'
import Button from '../../../shared/button'

const ManageGuides = ({ guides }) => {
  const navigate = useNavigate()
  const { getCategoriesString } = useGetCategoryName()

  if (!guides?.length) {
    return null
  }

  const navigateToGuide = (guide) => {
    navigate(`/admin-manage-guides/${guide.id}`)
  }

  const navigateToCommonQuestions = () => {
    navigate('/admin-manage-guides/common-questions')
  }

  return (
    <div className="grid gap-3">
      <div className="flex mb-4 justify-between">
        <Button mode="default" onClick={navigateToCommonQuestions}>
          TODO Common Questions
        </Button>
        <CreateGuideDialog onGuideCreated={navigateToGuide} />
      </div>

      {guides.map((guide) => {
        const { id, active, categories, locales } = guide

        return (
          <div
            key={id}
            className={cx(
              'p-3 border border-gray-300 shadow-sm bg-white cursor-pointer rounded flex flex-col border-l-8 gap-1',
              {
                'border-l-red-600': !active,
                'border-l-green-600': active
              }
            )}
            onClick={() => navigateToGuide(guide)}
          >
            <span className="font-medium">{getCategoriesString(categories)}</span>
            <span className="flex gap-1">
              {locales?.length > 0 &&
                locales.map((locale) => (
                  <Flag key={locale} locale={locale} height="16px" />
                ))}
            </span>
          </div>
        )
      })}
    </div>
  )
}

ManageGuides.propTypes = {
  guides: array
}

ManageGuides.defaultProps = {}

export default ManageGuides
